import { render, staticRenderFns } from "./UserProfileActionsDialog.vue?vue&type=template&id=357dc5ec&"
import script from "./UserProfileActionsDialog.vue?vue&type=script&lang=ts&"
export * from "./UserProfileActionsDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports